/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

// Evitar errores si GSAP no está cargado
if (typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined") {

  gsap.registerPlugin(ScrollTrigger);

  const blocks = document.querySelectorAll(".js-gsap-vectorbackground");

  blocks.forEach((block) => {

    gsap.from(block, {      
      opacity: 0,       
      duration: 1.2,
      scrollTrigger: {
        trigger: block,        // El bloque que dispara la animación
        start: "100% 20%",      // Cuando el top del bloque esté al 80% del viewport
        end: "235% 100%",     // Cuando el bottom del bloque llegue al 20% del viewport
        markers: false,      // Mostrar indicadores de start/end
    scrub: true
      }
    });

  });

}
